import { render, staticRenderFns } from "./FeatureDashboard.vue?vue&type=template&id=7ddbf0fa&scoped=true&"
import script from "./FeatureDashboard.vue?vue&type=script&lang=js&"
export * from "./FeatureDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FeatureDashboard.vue?vue&type=style&index=0&id=7ddbf0fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddbf0fa",
  null
  
)

export default component.exports